import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import CompanyLayout from '../components/CompanyLayout';
import SharedMessages from '../../shared/messages/pages/Messages';

/**
 * Company/Recruiter Messages Page
 * Uses CompanyLayout structure
 * Protected Route: Only accessible to authenticated company/recruiter users
 */
const Messages: React.FC = () => {
  // Auth is handled by JWT tokens in API calls - no need for candidate-specific auth protection

  const [searchParams] = useSearchParams();
  const [userName, setUserName] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userId, setUserId] = useState('');

  // Get application ID from query params (e.g., ?application=123)
  const applicationId = searchParams.get('application');

  // Get user data from localStorage
  useEffect(() => {
    const userDataString = localStorage.getItem('authUser');
    if (userDataString) {
      try {
        const userData = JSON.parse(userDataString);
        // Backend now provides company_name directly for company/recruiter users
        const name = userData.firstName && userData.lastName
          ? `${userData.firstName} ${userData.lastName}`
          : userData.email?.split('@')[0] || 'User';

        setUserName(name);
        setUserEmail(userData.email || '');
        setUserId(userData.id || '');

        console.log('Company Messages - User data:', {
          userName: name,
          userEmail: userData.email,
          userId: userData.id,
          companyName: userData.companyName,
          userRole: userData.userType || userData.role
        });
      } catch (error) {
        console.error('Failed to parse user data:', error);
      }
    }

    // Log if we have an application ID to auto-open
    if (applicationId) {
      console.log('Company Messages - Auto-opening conversation for application:', applicationId);
    }
  }, [applicationId]);

  // User data from localStorage
  const mockUser = {
    id: userId,
    name: userName,
    email: userEmail,
    avatar: undefined,
  };

  return (
    <CompanyLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-semibold text-[#0B111E]">Messages</h1>
        <p className="text-base font-normal text-[#515151] mt-1">
          View and manage your conversations with candidates
        </p>
      </div>

      {/* Messages Component */}
      <SharedMessages
        userRole="recruiter"
        user={mockUser}
        initialConversationId={applicationId || undefined}
      />
    </CompanyLayout>
  );
};

export default Messages;
